/**
 * @generated SignedSource<<b2a01c60df9f819e9dfd6a6c0410eda4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlocksData$data = {
  readonly blocks: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BlocksBlockData">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"BlocksRealmData">;
  readonly " $fragmentType": "BlocksData";
};
export type BlocksData$key = {
  readonly " $data"?: BlocksData$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlocksData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlocksData",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlocksRealmData"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BlocksBlockData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};

(node as any).hash = "afde670c4924aadccbc97bf34700e52d";

export default node;
